"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageUrlUtil = /** @class */ (function () {
    function ImageUrlUtil() {
    }
    ImageUrlUtil.resize = function (url, maxWidth, maxHeight) {
        if (maxWidth === void 0) { maxWidth = '-'; }
        if (maxHeight === void 0) { maxHeight = '-'; }
        var imgPrefix = '/img/';
        if (url === undefined || url === null || url.length == 0 || url.endsWith('.svg')) {
            return url;
        }
        var prefixes = [];
        prefixes.push('//static.test.aperza.com' + imgPrefix);
        prefixes.push('https://static.test.aperza.com' + imgPrefix);
        prefixes.push('//static.stg.aperza.com' + imgPrefix);
        prefixes.push('https://static.stg.aperza.com' + imgPrefix);
        prefixes.push('//static.aperza.com' + imgPrefix);
        prefixes.push('https://static.aperza.com' + imgPrefix);
        for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
            var prefix = prefixes_1[_i];
            if (url.startsWith(prefix)) {
                return (prefix.substring(0, prefix.length - imgPrefix.length) +
                    '/' +
                    maxWidth +
                    'x' +
                    maxHeight +
                    '/img/' +
                    url.substring(prefix.length));
            }
        }
        return url;
    };
    return ImageUrlUtil;
}());
exports.default = ImageUrlUtil;
//# sourceMappingURL=ImageUrlUtil.js.map